import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BulkDataView, BulkDataConfirmHandler } from './BulkDataView'
import { ProcessJobType } from 'epc-schema'

export const BulkDistrictDataView: React.FC = () => {
  const navigate = useNavigate()
  const handleCancel = () => navigate('/admin/management')

  const handleConfirm: BulkDataConfirmHandler = async () => {
    navigate('/admin/management/districts', { replace: true })
  }

  return (
    <BulkDataView
      fields={{
        district: 'School District',
        school: 'School Name',
        city: 'County',
      }}
      returnUrl="/admin/management/districts"
      linkText="back to district quick actions"
      heading="Import Bulk District Data"
      onCancel={handleCancel}
      jobType={ProcessJobType.ImportSchools}
      onConfirm={handleConfirm}
    />
  )
}
